<template>
  <v-dialog v-model="dialog" persistent max-width="1100px" ref="winContact">
    <v-card>
      <v-card-title>
        <div class="d-flex flex-row winedit-container-header">
          <h1>
            Edition d'un
            <span class="bis">contact {{row_co | formatContactName}}</span>
          </h1>
        </div>
      </v-card-title>
      <!-- <v-card-text grid-list-xl> -->
      <v-card-text :style="stylecontainer">
        <m-form ref="mainform" :rules="[validateMainForm]">
          <v-container fluid pa-0 grid-list-xl formlittle ref="mycontainer">
            <v-card class="mt-3 card2">
              <v-card-title>
                <h3>Identité</h3>
              </v-card-title>
              <v-card-text>
                <v-layout>
                  <v-flex md2>
                    <m-form-select
                      :items="$store.state.items_co_civilites"
                      v-model="row_co.co_civility"
                      label="Civilité"
                      :label-width="6"
                    ></m-form-select>
                    <m-form-file
                      class="input-avatar"
                      label="avatar"
                      ref="inputAvatar"
                      @inputfile="saveAvatar"
                    />
                  </v-flex>
                  <v-flex md4>
                    <m-form-text
                      label="Nom"
                      ref="co_name"
                      :label-width="2"
                      :name="$Utils.randomstring('co_name')"
                      v-model="row_co.co_name"
                    ></m-form-text>
                    <v-checkbox
                      class="pt-3"
                      v-if="row_co.co_avatar"
                      label="Effacer l'avatar"
                      v-model="row_co.deleteavatar"
                    ></v-checkbox>
                  </v-flex>
                  <v-flex md3>
                    <m-form-text
                      label="Prénom"
                      :name="$Utils.randomstring('co_firstname')"
                      v-model="row_co.co_firstname"
                    ></m-form-text>
                    <m-form-text
                      label="Identfiant"
                      :name="$Utils.randomstring('co_login')"
                      v-model="row_co.co_login"
                    ></m-form-text>
                  </v-flex>
                  <v-flex md3>
                    <m-form-text
                      label="Fonction"
                      :name="$Utils.randomstring('co_function')"
                      v-model="row_co.co_function"
                    ></m-form-text>
                    <m-form-text
                      label="Pass"
                      :name="$Utils.randomstring('co_password')"
                      v-model="row_co.co_password"
                    ></m-form-text>
                  </v-flex>
                </v-layout>
              </v-card-text>
            </v-card>

            <v-card class="mt-5 fill-height card3">
              <v-card-title>
                <h3>Coordonnées</h3>
              </v-card-title>
              <v-card-text>
                <v-layout>
                  <v-flex mb6>
                    <m-form-text
                      label="e-mail"
                      :name="$Utils.randomstring('co_email')"
                      v-model="row_co.co_email"
                    ></m-form-text>
                    <m-form-text
                      label="Téléphone "
                      :name="$Utils.randomstring('co_tel')"
                      v-model="row_co.co_tel"
                    ></m-form-text>
                  </v-flex>

                  <v-flex mb6>
                    <m-form-text
                      label="Adresse ligne 1"
                      :label-width="3"
                      :name="$Utils.randomstring('co_address1')"
                      v-model="row_co.co_address1"
                    ></m-form-text>
                    <transition name="slide-fade">
                      <m-form-text
                        label="Adresse ligne 2"
                        :label-width="3"
                        :name="$Utils.randomstring('co_address2')"
                        v-show="row_co.co_address1"
                        v-model="row_co.co_address2"
                      ></m-form-text>
                    </transition>
                    <transition name="slide-fade">
                      <m-form-text
                        label="Adresse ligne 3"
                        :label-width="3"
                        :name="$Utils.randomstring('co_address3')"
                        v-show="row_co.co_address2"
                        v-model="row_co.co_address3"
                      ></m-form-text>
                    </transition>
                    <div class="d-flex flex-row">
                      <div class="flex-grow-1">
                        <m-form-text
                          label="CP / Ville"
                          :label-width="5"
                          :name="$Utils.randomstring('co_zip')"
                          v-model="row_co.co_zip"
                        ></m-form-text>
                      </div>
                      <div class="flex-grow-1">
                        <m-form-text
                          :label-width="0"
                          :name="$Utils.randomstring('co_city')"
                          v-model="row_co.co_city"
                        ></m-form-text>
                      </div>
                    </div>
                    <m-form-select
                      label="Pays"
                      :readonly="false"
                      :label-width="3"
                      :items="$store.state.items_countries"
                      :name="$Utils.randomstring('co_country')"
                      v-model="row_co.co_country"
                    ></m-form-select>
                  </v-flex>
                </v-layout>
              </v-card-text>
            </v-card>
            <v-card class="mt-5 fill-height card3">
              <v-card-title>
                <h3>Droits</h3>
              </v-card-title>
              <v-card-text>
                <div class="right-preference">
                  <v-row>
                    <v-col>
                      <table class="tablestriped blackheader backgroud-white">
                        <tbody>
                          <tr v-for="(right, index) in $store.state.rights" :key="index">
                            <td class="bis">{{right.text}}</td>
                            <td>
                              <v-simple-checkbox
                                v-model="row_co.co_right[right.value]"
                                :disabled="!$store.state.myrights.Create_contact"
                              ></v-simple-checkbox>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </v-col>
                  </v-row>
                </div>
              </v-card-text>
            </v-card>
          </v-container>
        </m-form>
      </v-card-text>
      <v-card-actions>
        <v-btn
          color="error2"
          depressed
          @click="confirmdelete=true"
          :disabled="!$store.state.myrights.Create_contact"
        >Effacer</v-btn>
        <v-btn
          color="error2"
          @click="archiveContact()"
          text
          :disabled="!$store.state.myrights.Create_contact"
        >Archiver</v-btn>
        <v-spacer></v-spacer>
        <v-btn color="primary2" text @click="cancelWin()">Annuler</v-btn>
        <v-btn color="primary2" depressed @click="saveWin()">Enregistrer</v-btn>
      </v-card-actions>
    </v-card>
    <m-confirm-dialog
      v-model="confirmdelete"
      text="Souhaitez-vous effacer ce contact ?"
      title="Confirmation"
      @canceled="confirmdelete=false"
      @confirmed="deleteWin()"
    ></m-confirm-dialog>
  </v-dialog>
</template>

<script>
export default {
  name: "ContactWinEdit",
  components: {},
  data() {
    // console.log(
    //   "this.$store.state.items_countries",
    //   this.$store.state.items_countries
    // );
    return {
      co_society_new: "",
      avatar: null,
      confirmdelete: false,
      dialog: false,
      row_co: { co_right: {} },
      stylecontainer: ``,
      clientsuivi: false
      // agentfollower: {}
      // switch1: false
    };
  },
  filters: {},
  computed: {},
  watch: {
    row_co() {
      this.setContainerStyle();
    }
  },

  props: {},
  mounted() {
    window.addEventListener("resize", this.setContainerStyle);
  },
  destroyed() {
    window.removeEventListener("resize", this.setContainerStyle);
  },
  created() {},
  methods: {
    saveAvatar(files) {
      if (files.length) this.avatar = files[0];
    },
    setContainerStyle() {
      this.$nextTick(() => {
        if (!this.$refs.mycontainer) return;
        if (this.$refs.mycontainer.clientHeight > window.innerHeight - 300)
          this.stylecontainer = `height: calc(100vh - 253px); overflow:auto;`;
        else this.stylecontainer = "";
      });
    },
    open(co_id) {
      // let co_id = this.$route.params.co_id;
      this.dialog = true;
      this.getContact(co_id);
    },
    async getContact(co_id) {
      this.avatar = null;
      if (this.$refs.inputAvatar) this.$refs.inputAvatar.reset();
      let params = {};
      if (co_id == "-1") params = {};
      let response = await this.$axios.get(
        this.$config.server_url + "/api/1.0/contacts/" + co_id,
        { params }
      );
      let row_co = response.data.data;
      this.row_co = row_co;
      if (!this.row_co.co_country) this.row_co.co_country = "FR";
      if (!row_co.co_right || row_co.co_right === "") {
        this.row_co.co_right = {
          see_contacts: false,
          Create_contact: false,
          import_matrice: false,
          see_catalogues: false,
          create_catalogue: false,
          edit_catalogue: false,
          export_catalogue: false,
          see_preferences: false,
          add_product: false
        };
      }
      setTimeout(() => {
        this.setContainerStyle();
      }, 10);
    },

    async validateMainForm(vEls) {
      // console.log("vEls", vEls);
      if (!this.row_co.co_society && !this.row_co.co_name) {
        this.$refs.co_name.informInvalid(
          "Le nom d'un contact ou d'une société est obligatoire"
        );
        this.$refs.co_society.informInvalid(
          "Le nom d'un contact ou d'une société est obligatoire"
        );
        return false;
      }
      return true;
    },
    async saveWin() {
      // console.log("this.avatar", this.avatar);
      if (!(await this.$refs.mainform.validate())) return;
      let response;
      delete this.row_co.events;
      delete this.row_co.newcustomers;
      delete this.row_co.properties;
      delete this.row_co.searches;
      delete this.row_co.co_preferences;
      delete this.row_co.co_searches;
      delete this.row_co.calls_user;
      delete this.row_co.calls_contact;
      delete this.row_co.todos_user;
      delete this.row_co.todos_todo_user;
      delete this.row_co.todos_contact;
      delete this.row_co.todos_todo_contact;
      delete this.row_co.signatures_sell_user;
      delete this.row_co.signatures_sell_contact;
      delete this.row_co.signatures_rent_user;
      delete this.row_co.signatures_rent_contact;
      delete this.row_co.emails_user;
      delete this.row_co.emails_contact;
      delete this.row_co.presents_user;
      delete this.row_co.presents_contact;
      delete this.row_co.visits_user;
      delete this.row_co.visits_contact;
      delete this.row_co.reports_user;
      delete this.row_co.reports_contact;
      delete this.row_co.reports_tocomplete;

      this.row_co.co_society_new = this.co_society_new;
      if (this.row_co.co_id) {
        // if (this.row_co.co_id_follower) {
        //   this.row_co.co_id_follower = this.row_co.co_id_follower.co_id;
        // }
        response = await this.$axios.put(
          this.$config.server_url + "/api/1.0/contacts/" + this.row_co.co_id,
          this.row_co
        );
      } else {
        response = await this.$axios.post(
          this.$config.server_url + "/api/1.0/contacts",
          this.row_co
        );
      }
      let row_co = response.data.data;
      if (this.avatar) {
        let formData = new FormData();
        formData.append("co_id", row_co.co_id);
        formData.append("image", this.avatar);
        await this.$axios.post(
          this.$config.server_url + "/api/1.0/avatar",
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data"
            }
          }
        );
      }

      if (row_co.co_id == this.$store.state.user.co_id) {
        this.$store.commit("set_user_simple", row_co);
      }
      this.dialog = false;
      // this.$store.dispatch("load_nbclientsuivi");
      this.$emit("contactWinEditSaved", row_co.co_id);
    },
    cancelWin() {
      this.dialog = false;
      this.$emit("contactWinEditCanceled", this.row_co.co_id);
    },
    async archiveContact() {
      let co_id = this.row_co.co_id;
      this.row_co.co_archived = true;
      await this.$axios.put(
        this.$config.server_url + "/api/1.0/contacts/" + co_id,
        this.row_co
      );
      this.$emit("contactWinEditDeleted", co_id);
    },
    async deleteWin() {
      let co_id = this.row_co.co_id;
      await this.$axios.delete(
        this.$config.server_url + "/api/1.0/contacts/" + co_id
      );
      this.confirmdelete = false;
      this.dialog = false;
      // this.$store.dispatch("load_nbclientsuivi");
      this.$emit("contactWinEditDeleted", co_id);
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.slide-fade-enter-active {
  transition: all 0.5s ease;
}
.slide-fade-leave-active {
  transition: all 0.5s cubic-bezier(1, 0.5, 0.8, 1);
}
.slide-fade-enter, .slide-fade-leave-to
/* .slide-fade-leave-active below version 2.1.8 */ {
  transform: translateY(-10px);
  opacity: 0;
}
.winedit-container-header {
  width: 100%;
  justify-content: space-between;
}
.input-avatar {
  padding: 0;
}
</style>
